import { Outlet } from "react-router-dom";
import { useState } from "react";
import Navbar from "./Navbar";
import "./Layout.css";

const Layout = () => {
  const [navOpen, setNavOpen] = useState(false);
  const [blockNavigation, setBlockNavigation] = useState(false);
  const [beforeNavigate, setBeforeNavigate] = useState(null);

  const toggleNav = () => {
    setNavOpen(prev => !prev);
  };

  const closeNav = () => {
    setNavOpen(false);
  };

  return (
    <>
      {/* 🔹 전역 햄버거 버튼 (네비바 밖에 둠) */}
      <button
        type="button"
        className="global-hamburger"
        onClick={toggleNav}
        aria-label="메뉴 열기"
      >
        <span />
        <span />
        <span />
      </button>

      <div className="layout">
        <Navbar
          isOpen={navOpen}
          onClose={closeNav}
          blockNavigation={blockNavigation}
          beforeNavigate={beforeNavigate}
        />
        <div className="content">
          <Outlet
            context={{
              setBlockNavigation,
              setBeforeNavigate,
            }}
          />
        </div>
      </div>
    </>
  );
};

export default Layout;